import React from 'react'
import {
  useAutoTemplateForm,
  usePreloadTemplateFormQueries,
  useRedirectInitializedZendeskApp,
  useTemplateId,
} from './AutoTemplateRoute.hooks'
import { TemplateStepsProvider, TemplateStep } from '@/features/templates'
import { Formik } from 'formik'
import classes from './AutoTemplateRoute.module.scss'

export const AutoTemplateRoute = () => {
  const templateId = useTemplateId()
  usePreloadTemplateFormQueries(templateId)
  useRedirectInitializedZendeskApp()
  const formikProps = useAutoTemplateForm(templateId)

  return (
    <Formik {...formikProps}>
      <div className={classes.root}>
        <div className={classes.content}>
          <TemplateStepsProvider templateId={templateId}>
            {({ steps, currentStep }) => (
              <TemplateStep key={currentStep} step={steps[currentStep]} templateId={templateId} />
            )}
          </TemplateStepsProvider>
        </div>
      </div>
    </Formik>
  )
}
